// extracted by mini-css-extract-plugin
module.exports = {"header":"e_0o","gallery":"e_1o","label":"e_2o"};